<template>
  <Tooltip>
    <template #element>
      <span>
        Verortung
      </span>
      <InformationCircleIcon class="info-icon" />
    </template>
    <template #content>
      <span>
        Beschreibung, ob die Methode im Audio-Format selbst angewandt wird (z.B. als Teil des Storytellings) oder in einem anderen Kanal
      </span>
    </template>
  </Tooltip>
</template>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
